/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationactionactioned2Inputs */

const en_moderationactionactioned2 = /** @type {(inputs: Moderationactionactioned2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark actioned`)
};

const de_moderationactionactioned2 = /** @type {(inputs: Moderationactionactioned2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als bearbeitet markieren`)
};

/**
* | output |
* | --- |
* | "Mark actioned" |
*
* @param {Moderationactionactioned2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationactionactioned2 = /** @type {((inputs?: Moderationactionactioned2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationactionactioned2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationactionactioned2(inputs)
	return de_moderationactionactioned2(inputs)
});
export { moderationactionactioned2 as "moderationActionActioned" }